module.exports = "/_next/static/media/d800ddf98e4a1367191324ebaaa903f3.svg";